import React from 'react'
import { Select, Option, Text, Flex, Box, Icon, PopoverProps } from '@chilipiper/design-system'
import { SvgArrowTriangleDown } from '@chilipiper/icons/src/arrow'
import { SystemProps } from '@chilipiper/design-system'
import { CopyLinkType } from './types'
import { useGetBookingLink } from './hooks'

interface Props {
  assigneeName?: string
  bookingLinkUrl?: string
  disabled?: boolean
  groupTemplateId?: string
  onSelectCopy: (copyLinkType: CopyLinkType, bookingLink?: string) => void
  popoverOffset?: PopoverProps['offset']
  popoverText: string
  templateId?: string
}

export const BookingLinksCardSelect = ({
  onSelectCopy,
  bookingLinkUrl,
  templateId,
  assigneeName,
  popoverOffset,
  popoverText,
  disabled,
  groupTemplateId,
  ...props
}: Props & SystemProps) => {
  const { getBookingLink } = useGetBookingLink({
    templateId,
    assigneeName,
    groupTemplateId,
    bookingLinkUrl,
  })

  const handleSelectCopy = async (copyLinkType: CopyLinkType) => {
    const bookingLink = await getBookingLink(copyLinkType)
    onSelectCopy(copyLinkType, bookingLink)
  }

  return (
    <Flex
      w='100%'
      data-test-id='BookingLinksCardSelect'
      justifyContent='center'
      alignItems='center'
      flexDirection='column'
      opacity={disabled ? 40 : props.opacity || 100}
      {...props}
    >
      <Box minWidth={92} w='100%'>
        <Select
          disabled={disabled}
          zIndex={30}
          isPortalForTarget
          onChange={handleSelectCopy}
          label='Select copy link'
          w='100%'
          optionsStyle={{
            sameWidth: false,
          }}
          offset={popoverOffset}
          maxWidth='212px'
          customPopoverTriggerStyles={{
            w: '100%',
          }}
          customPopoverTrigger={
            <Flex justifyContent='center' flexDirection='row'>
              <Text color='teal-dark-100' fontWeight={600}>
                {popoverText}
              </Text>
              <Icon ml={2} color='neutral-dark-32' icon={SvgArrowTriangleDown} />
            </Flex>
          }
        >
          <Option value={CopyLinkType.CopyLink}>
            <Text>{CopyLinkType.CopyLink}</Text>
          </Option>
          <Option value={CopyLinkType.CopySingleUseLink}>
            <Text>{CopyLinkType.CopySingleUseLink}</Text>
          </Option>
        </Select>
      </Box>
    </Flex>
  )
}
